import { render } from "./ErrorPage404.vue?vue&type=template&id=1bd9ae90"
import script from "./ErrorPage404.vue?vue&type=script&lang=js"
export * from "./ErrorPage404.vue?vue&type=script&lang=js"

import "./ErrorPage404.vue?vue&type=style&index=0&id=1bd9ae90&lang=scss"

import exportComponent from "/var/www/prod.storm.ms/actions-runner/storm-site/storm-site/storm-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__